import {AfterViewInit, Directive, ElementRef, inject, model} from '@angular/core'

@Directive({
  selector: '[spbText]'
})
export class Text implements AfterViewInit {

  private readonly el = inject(ElementRef)

  public text = model<string>()

  public ngAfterViewInit(): void {
    this.text.set(this.el.nativeElement.textContent)
  }
}
